import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Multiselect } from "multiselect-react-dropdown";
import { newDevelopmentActions, newDevelopmentSelectors } from "state/newDevelopment";
import { TooltipType } from "../../../../../../sharedComponents/Tooltip/config";
import { subscriptionSelectors } from "../../../../../../../state/subscription";
import { Tier } from "../../../../../../../types/Tier";

const STYLE = {
  chips: {
    background: "#3A4276",
    borderRadius: "0",
    textTransform: "uppercase",
  },
  searchBox: {
    border: "none",
  },
  multiselectContainer: {
    color: "FFFFFF",
  },
  optionContainer: {
    background: "#3A4276",
    color: "FFFFFF",
  },
  option: {
    color: "white",
    font: "Bold",
    textTransform: "uppercase",
  },
};

const OwnerAddressFilters = () => {
  const dispatch = useDispatch()
  const enabledOwnerAddressFilter = useSelector(newDevelopmentSelectors.getEnabledOwnerAddressFilter);
  const disabledOwnerAddressFilter = useSelector(newDevelopmentSelectors.getDisabledOwnerAddressFilter);
  const tier = useSelector(subscriptionSelectors.getTier);
  const isDemoUser = tier === Tier.None;
  const dataTip = isDemoUser ? TooltipType.SmartSearch : null;

  return (
    <div className="component--owner-address-filters">
      <div className="count-wrapper section-divisor">
        <label>Owner Address</label>
      </div>

      <div className="owner-address-dropdown-box" data-for="click-right" data-tip={dataTip}>
        <Multiselect
          options={disabledOwnerAddressFilter}
          selectedValues={enabledOwnerAddressFilter}
          onSelect={(selectedList, selectedOwnerAddress) => dispatch(newDevelopmentActions.updateOwnerAddressesFilterValues({ [selectedOwnerAddress]: true }))}
          onRemove={(selectedList, selectedOwnerAddress) => dispatch(newDevelopmentActions.updateOwnerAddressesFilterValues({ [selectedOwnerAddress]: false }))}
          isObject={false}
          placeholder="Click here to search for owner mailing addresses."
          style={STYLE}
          avoidHighlightFirstOption={true}
          closeIcon="cancel"
          disable={isDemoUser}
        />
      </div>
    </div>
  );
}

export default OwnerAddressFilters;
